<div id="course-duration-loading" *ngIf="courseDurationLoading">
    <i class="fa fa-spinner fa-spin"></i>
    <span>Cargando información de duración del curso...</span>
</div>

<div id="course-duration-info" *ngIf="!courseDurationLoading">

    <div id="course-duration-detailed-info">
        <h2>Información detallada del curso</h2>
    
        <table class="table">
            <thead>
                <th>TIPO PÁGINA</th>
                <th>OBLIGATORIO / RECOMENDADO</th>
                <th>Nº</th>
                <th>TIEMPO UNITARIO</th>
                <th>TIEMPO TOTAL</th>
            </thead>
            <tbody>
                <tr>
                    <td class="fw-bold">Unidades</td>
                    <td>---</td>
                    <td [ngClass]="{'text-danger fw-bold' : !unitsReq }">{{ unitsNum }}</td>
                    <td>5 min.</td>
                    <td>{{ unitsTime }} min.</td>
                </tr>
                <tr>
                    <td class="fw-bold">Objetivos</td>
                    <td>Obligatorio: 1 por UA</td>
                    <td [ngClass]="{'text-danger fw-bold' : !objReq }">{{ objNum }}</td>
                    <td>5 min.</td>
                    <td>{{ objTime }} min.</td>
                </tr>
                <tr>
                    <td class="fw-bold">Resumen</td>
                    <td>Obligatorio: 1 por UA</td>
                    <td [ngClass]="{'text-danger fw-bold' : !summariesReq }">{{ summariesNum }}</td>
                    <td>5 min.</td>
                    <td>{{ summariesTime }} min.</td>
                </tr>
                <tr>
                    <td class="fw-bold">Lecciones</td>
                    <td>---</td>
                    <td>{{ lessonsNum }}</td>
                    <td>---</td>
                    <td>---</td>
                </tr>
                <tr>
                    <td class="fw-bold">Evaluación</td>
                    <td>Obligatorio: 1 por Lección</td>
                    <td [ngClass]="{'text-danger fw-bold' : !testsReq }">{{ testsNum }}</td>
                    <td>2 min.</td>
                    <td>{{ testsTime }} min.</td>
                </tr>
                <tr>
                    <td class="fw-bold">Caso práctico</td>
                    <td>Recomendado: 3 por cada 20 horas de curso</td>
                    <td [ngClass]="{'text-danger fw-bold' : !cpReq }">{{ cpNum }}</td>
                    <td>15 min.</td>
                    <td>{{ cpTime }} min.</td>
                </tr>
                <tr>
                    <td class="fw-bold">Actividades</td>
                    <td>Obligatorio: 1 por cada 2-3 lecciones</td>
                    <td [ngClass]="{'text-danger fw-bold' : !activitiesReq }">{{ activitiesNum }}</td>
                    <td>15 min.</td>
                    <td>{{ activitiesTime }} min.</td>
                </tr>
                <tr>
                    <td class="fw-bold" colspan="2">Enunciados</td>
                    <td>{{ headingsNum }}</td>
                    <td>5 min.</td>
                    <td>{{ headingsTime }} min.</td>
                </tr>
                <tr>
                    <td class="fw-bold" colspan="4">Tiempo total</td>
                    <td>{{ totalTime }} min.</td>
                </tr>
            </tbody>
        </table>
    
        <div id="course-duration-detail-info-result">
            <p>Contenido elaborado: <b>{{ totalTime }} min. = {{ totalTimeHours }} horas</b></p>
            <p>Duración TOTAL del curso elaborado: <b>{{ totalTimeHoursCourse }} horas</b> *</p>
            <p>* El contenido elaborado corresponde al 55% de la duración total del curso</p>
        </div>
    
    </div>
    
    <div id="course-duration-unit-breakdown">
        <h2>Correspondencia de horas por UAs</h2>
    
        <table class="table" *ngFor="let unit of courseDurationDetail; let u = index;">
            <tr class="fw-bold">
                <td colspan="2">{{ unit.name }}</td>
            </tr>
            <tr>
                <td class="fw-bold">Esquema de contenidos o mapa conceptual</td>
                <td>5 min.</td>
            </tr>
            <tr>
                <td colspan="2">
                    <table class="table" *ngFor="let lesson of unit.lessons; let l = index;">
                        <tr class="fw-bold">
                            <td colspan="2">{{ lesson.name }}</td>
                        </tr>
                        <tr *ngFor="let page of lesson.pages; let p = index;">
                            <td><b>Enunciado:</b> {{ page.name }}</td>
                            <td>{{ page.time }} min.</td>
                        </tr>
                        <tr *ngFor="let activity of lesson.activities; let a = index;">
                            <td>{{ activity.name }}</td>
                            <td>{{ activity.time }} min.</td>
                        </tr>
                        <tr *ngFor="let test of lesson.tests; let t = index;">
                            <td>{{ test.name }}</td>
                            <td>{{ test.time }} min.</td>
                        </tr>
                        <tr>
                            <td class="fw-bold">Tiempo de la lección:</td>
                            <td>{{ lesson.time }} min. ({{ lesson.timeHours }} h.)</td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr *ngFor="let objective of unit.objectives; let o = index;">
                <td>{{ objective.name }}</td>
                <td>{{ objective.time }} min.</td>
            </tr>
            <tr *ngFor="let summary of unit.summaries; let s = index;">
                <td>{{ summary.name }}</td>
                <td>{{ summary.time }} min.</td>
            </tr>
            <tr class="fw-bold">
                <td colspan="2">
                    Contenido elaborado UA{{ u + 1 }}: {{ unit.time }} min. ({{ unit.timeHours }} h.)
                </td>
            </tr>
            <tr class="fw-bold">
                <td colspan="2">
                    Duración total {{ unit.name }}: {{ unit.timeTotalHours }} h.
                </td>
            </tr>
        </table>

        <hr>
    
    </div>

</div>